import classnames from 'classnames';
import TransportIcon from 'components/TransportIcon';
import BoltIcon from 'components/icons/BoltIcon';
import LeafIcon from 'components/icons/LeafIcon';
import StarIcon from 'components/icons/StarIcon';
import React, { useMemo } from 'react';

import FamilyFriendlyIcon from '../icons/FamilyFriendlyIcon';

const CSS = require('./ExperienceCardLabels.module.scss');

interface ExperienceCardLabelsProps {
  isInstantlyConfirmed: boolean;
  isFamilyFriendly: boolean;
  transportMode?: string;
  subCategory: string;
  hasPositiveImpact?: boolean;
}

function getCleanCategory(subCategory = 'tour'): string {
  return subCategory
    .replace('tours', 'tour')
    .replace('workshops', 'workshop')
    .replace('trips', 'trip')
    .replace('tastings', 'tasting')
    .replace('classes', 'class')
    .replace('virtual attractions', 'Online experience');
}

function getCleanTransport(transportMode = 'notApplicable'): string | null {
  if (
    !transportMode ||
    transportMode === 'other' ||
    transportMode === 'notApplicable' ||
    transportMode === 'walkingTour'
  ) {
    return null;
  }

  return transportMode
    .replace('Tour', '')
    .replace('bicycle', 'Bike')
    .replace('publicTransport', 'Public transport');
}

function ExperienceCardLabels({
  isInstantlyConfirmed,
  isFamilyFriendly,
  transportMode,
  subCategory,
  hasPositiveImpact,
}: ExperienceCardLabelsProps) {
  const { category, transport } = useMemo(() => {
    return {
      category: getCleanCategory(subCategory),
      transport: getCleanTransport(transportMode),
    };
  }, [subCategory, transportMode]);

  return (
    <div className={CSS.ExperienceCardLabels}>
      <span className={classnames(CSS.Label, CSS.CategoryLabel)}>
        <StarIcon className={CSS.StarIcon} />
        {category}
      </span>
      {transport && (
        <span className={CSS.Label}>
          <TransportIcon name={transportMode} className={CSS.TransportIcon} />
          {transport}
        </span>
      )}
      {isInstantlyConfirmed && (
        <span className={CSS.Label}>
          <BoltIcon className={CSS.BoltIcon} />
          Instantly Confirmed
        </span>
      )}
      {isFamilyFriendly && (
        <span className={CSS.Label}>
          <FamilyFriendlyIcon className={CSS.GroupIcon} />
          Family Friendly
        </span>
      )}
      {hasPositiveImpact && (
        <span className={CSS.Label}>
          <LeafIcon className={CSS.LeafIcon} />
          Positive impact
        </span>
      )}
    </div>
  );
}

export default ExperienceCardLabels;
